<template>
  <div>
    <v-divider v-if="hasHost || hasVisitor" class="my-8" />

    <v-row>
      <v-col v-if="hasHost" cols="12" md="6">
        <v-row>
          <v-col>
            <h2>
              {{ $t('appointment.label.hostData') }}

              <!--
                <v-btn
                v-if="showFeedbackButton"
                :href="`/host-rate/${appointment.id}?realEstate=true`"
                target="_blank"
                color="primary"
                elevation="0"
                class="ml-5"
                small
                link
              >
                <v-icon left>
                  mdi-star-check-outline
                </v-icon>
                <span class="body-2">
                  {{ $t('hostRating.label.rate') }}
                </span>
              </v-btn>
              -->
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="12">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.label.hostName') }}
            </h6>
            <span class="body-2">
              {{ host ? host.name : '---' }}
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="host && host.phone" md="4">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.label.hostPhone') }}
            </h6>
            <span class="body-2" v-html="whatsApp(host.phone)"></span>
          </v-col>
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.label.hostMail') }}
            </h6>
            <span
              v-if="host && host.username"
              v-html="mailto(host.username)"
              class="body-2"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="4">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.label.hostRg') }}
            </h6>
            <span class="body-2">
              {{ hostRG }}
            </span>
          </v-col>
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.formCreate.labels.visitorDocument') }}
            </h6>
            <span class="body-2">
              {{ hostCPF ? formatDocument(hostCPF) : '---' }}
            </span>
          </v-col>
        </v-row>
      </v-col>

      <v-col v-if="hasVisitor" cols="12" md="6">
        <v-row>
          <v-col>
            <h2>
              {{
                isRentOut
                  ? $t('appointment.label.tenantData')
                  : $t('appointment.label.visitorData')
              }}
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="12">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.label.visitorName') }}
            </h6>
            <span class="body-2">
              {{ appointment.visitor_name }}
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.label.visitorPhone') }}
            </h6>
            <span
              v-if="appointment.visitor_phone"
              v-html="whatsApp(appointment.visitor_phone)"
              class="body-2"
            />
            <span v-else> --- </span>
          </v-col>
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.label.visitorMail') }}
            </h6>
            <span
              class="body-2"
              v-html="mailto(appointment.visitor_mail)"
            ></span>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-if="
              appointment.visitor_document &&
              appointment.visitor_document.length >= 11
            "
          >
            <p class="mb-0 body-2">
              <h6 class="text-uppercase grey--text">
                {{ $t('appointment.formCreate.labels.visitorDocument') }}
              </h6>
              <span class="body-2">
                {{
                  appointment.visitor_document
                    ? formatDocument(appointment.visitor_document)
                    : '---'
                }}
              </span>
            </p>
          </v-col>
          <v-col
            v-if="
              appointment.visitor_birth_date &&
              appointment.visitor_birth_date.length >= 21
            "
          >
            <p class="mb-0 body-2">
              <h6 class="text-uppercase grey--text">
                {{ $t('appointment.formCreate.labels.visitorBirthDate') }}
              </h6>
              <span class="body-2">
                {{ formatDate(appointment.visitor_birth_date) }}
              </span>
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mailto,
  whatsApp,
  catalogPhone,
  catalogDateWithoutTime,
} from '@/util/catalog'
import { formatDocument } from '@/util/document'
import { rentOutTypes } from '@/components/appointment/formFieldsCreate/appointmentFormDefaults'

export default {
  name: 'AppointmentHostAndVisitor',

  props: {
    appointment: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasHost() {
      return this.appointment?.host !== null
    },

    hasVisitor() {
      return this.appointment?.visitor_name !== null
    },

    showFeedbackButton() {
      return this.appointment?.real_estate_feedback === null
    },

    host() {
      return this.appointment?.host
    },

    isRentOut() {
      return rentOutTypes.includes(this.appointment?.type)
    },

    hostPhone() {
      return catalogPhone(this.host?.phone)
    },

    hostRG() {
      return this.host?.rg ?? '---'
    },

    hostCPF() {
      return this.host?.cpf ?? null
    },

    visitorPhone() {
      return catalogPhone(this.appointment?.visitor_phone)
    },
  },

  data() {
    return {
      mailto,
      whatsApp,
      formatDocument,
      formatDate: catalogDateWithoutTime,
    }
  },
}
</script>
